// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixit-expansion-panel[data-v-edc977f8]{border-bottom:2px solid var(--v-primary-base);font-weight:700}.v-expansion-panel-header[data-v-edc977f8]{background-color:#fff!important}.v-expansion-panel-header--active[data-v-edc977f8]{background-color:#fff!important;min-height:48px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
